import { render, staticRenderFns } from "./VrsteSkupova.vue?vue&type=template&id=a2e5e502&scoped=true&"
import script from "./VrsteSkupova.vue?vue&type=script&lang=js&"
export * from "./VrsteSkupova.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e5e502",
  null
  
)

export default component.exports